/**
 * Login API
 *
 * @author minkyoung.park@emcast.com
*/
import httpService from '@/api/httpService'

const rewardApi = {
    // Recent Badge
    // https://clpapi.tinkeredu.co.kr/static/docs/badge.html#_3_2_%EB%B1%83%EC%A7%80_%EC%A0%95%EB%B3%B4_badge_information
    rewardRecentBadge() {
        return httpService.get('/reward/badge/achieved/recent')
    },

    // Recent Certificate
    // https://clpapi.tinkeredu.co.kr/static/docs/certificate.html#_1_4_%EC%B5%9C%EA%B7%BC_%EC%88%98%EB%A3%8C%ED%95%9C_%EC%88%98%EB%A3%8C%EC%A6%9D_recently_completed_certificate
    rewardRecentCertificate() {
        return httpService.get('/reward/certificate/recent')
    },

    // Badge List
    // https://clpapi.tinkeredu.co.kr/static/docs/badge.html#_1_1_%EB%AA%A9%EB%A1%9D_%ED%8E%98%EC%9D%B4%EC%A7%95_list_paging
    rewardBadgeList(params) {
        if(params.status=='BADGE'){
            return httpService.get('/reward/badge/achieved',params)
        } else{
            return httpService.get('/reward/badge/achieving',params)
        }
    },

    // Badge Detail
    // https://clpapi.tinkeredu.co.kr/static/docs/badge.html#_2_3_%EC%83%81%EC%84%B8_details_request_headers
    badgeDetail(params) {
        return httpService.get('/reward/badge/achieved/detail',params)
    },

    // 수료가능 뱃지 상세
    badgeAchievingDetail(params) {
        return httpService.get(`/reward/badge/achieving/${params.id}`,params)
    },

    // Certificate List
    // https://clpapi.tinkeredu.co.kr/static/docs/certificate.html#_1_2_%EB%AA%A9%EB%A1%9D_list
    rewardCertificateList(params) {
        return httpService.get('/reward/certificate',params)
    },

    // Certificate Detail
    // https://clpapi.tinkeredu.co.kr/static/docs/certificate.html#_1_3_%EC%83%81%EC%84%B8_details_path_parameters
    certificateDetail(id) {
        return httpService.get('/reward/certificate/'+id)
    },

    

    // 로그 아웃(logout)
    // 
    logout() {
        return httpService.put('/auth/logout')
    },

    // 토큰 유효성 체크(Token Validity Check)
    validToken() {
        return httpService.get('/auth/valid')
    },

    // 헤더 토큰 설정(set Header Token)
    setAuthInHeader(token) {
        localStorage.setItem('token', token)
        httpService.setAuthInHeader(token)
    }
}

export default rewardApi
